(function () {
  function qs(root, sel) { return (root || document).querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var INIT_DELAY = 120;

  function initOneSlider(sliderEl) {
    if (typeof Flickity === 'undefined') {
      console.warn('[GWA] Flickity is undefined, skip');
      return;
    }

    var flkty = Flickity.data(sliderEl);
    if (!flkty) {
      console.warn('[GWA] Flickity instance not found yet, skip', sliderEl);
      return;
    }

    if (sliderEl.__gwaControlsInited) return;

    var inner = sliderEl;
    if (!inner) return;

    if (qs(inner, '[data-gwa-slide-controls]')) {
      sliderEl.__gwaControlsInited = true;
      console.log('[GWA] Controls already exist, ok');
      return;
    }

    sliderEl.__gwaControlsInited = true;

    var controls = document.createElement('div');
    controls.setAttribute('data-gwa-slide-controls', '1');
    controls.className = 'gwa-slide-controls';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'gwa-slide-controls__btn gwa-slide-controls__btn--prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = '<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.875 1.875L3.75 8L9.875 14.125L8 16L1.39876e-06 8L8 1.39876e-06L9.875 1.875Z" fill="black"/></svg>';

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'gwa-slide-controls__btn gwa-slide-controls__btn--next';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.innerHTML = '<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-1.23485e-06 14.125L6.125 8L-1.63918e-07 1.875L1.875 -6.99382e-07L9.875 8L1.875 16L-1.23485e-06 14.125Z" fill="black"/></svg>';

    function goPrev(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      flkty.previous();
    }
    function goNext(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      flkty.next();
    }

    prevBtn.addEventListener('pointerdown', goPrev, { passive: false });
    nextBtn.addEventListener('pointerdown', goNext, { passive: false });

    controls.appendChild(prevBtn);
    controls.appendChild(nextBtn);
    inner.appendChild(controls);

    function updateDisabledState() {
      var maxIndex = (flkty.cells ? flkty.cells.length : 0) - 1;
      var idx = flkty.selectedIndex || 0;

      prevBtn.disabled = idx <= 0;
      prevBtn.setAttribute('aria-disabled', String(idx <= 0));

      nextBtn.disabled = idx >= maxIndex;
      nextBtn.setAttribute('aria-disabled', String(idx >= maxIndex));
    }

    updateDisabledState();
    flkty.on('select', updateDisabledState);
    flkty.on('change', updateDisabledState);
    flkty.on('settle', updateDisabledState);

    console.log('[GWA] Controls initialized успешно ✅', {
      selectedIndex: flkty.selectedIndex,
      cells: flkty.cells ? flkty.cells.length : 0,
      el: sliderEl
    });
  }

  function initAll() {
    var sliders = qsa(document, '.product-slideshow.flickity-enabled');
    if (!sliders.length) {
      console.warn('[GWA] No sliders found');
      return;
    }
    sliders.forEach(initOneSlider);
  }

  function start() {
    setTimeout(function () {
      initAll();

      setTimeout(initAll, 400);
    }, INIT_DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


/* Move .price_tag_line into .product-single__meta .jdgm-widget.jdgm-preview-badge
   + add heading inside .price_tag_line on load + on variant changes (vanilla JS) */

(function () {
  const TARGET_SELECTOR = '.product-single__meta .jdgm-widget.jdgm-preview-badge';
  const LINE_SELECTOR = '.price_tag_line';
  const HEADING_CLASS = 'price_tag_line__heading';
  const HEADING_TEXT = 'Inhalt & Reichweite:';

  let scheduled = false;

  function ensureHeading(lineEl) {
    if (!lineEl || lineEl.querySelector('.' + HEADING_CLASS)) return;

    const heading = document.createElement('div');
    heading.className = HEADING_CLASS;
    heading.textContent = HEADING_TEXT;

    lineEl.insertBefore(heading, lineEl.firstChild);
  }

  function movePriceTagLine() {
    const line = document.querySelector(LINE_SELECTOR);
    if (!line) return;

    ensureHeading(line);

    const target = document.querySelector(TARGET_SELECTOR);
    if (!target) return;

    if (line.parentElement !== target) {
      target.appendChild(line);
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      movePriceTagLine();
    });
  }

  function isVariantControl(el) {
    if (!el || el.nodeType !== 1) return false;
    return (
      el.matches('[data-variant-input]') ||
      el.matches('select[name="id"]') ||
      el.matches('input[name="id"]') ||
      el.closest?.('[data-variant-input]') ||
      el.closest?.('select[name="id"]') ||
      el.closest?.('input[name="id"]')
    );
  }

  function setupVariantListeners() {
    document.addEventListener(
      'change',
      function (e) {
        if (isVariantControl(e.target)) schedule();
      },
      true
    );

    ['variant:change', 'variant:changed', 'product:variant-change', 'variantChange'].forEach(
      function (evt) {
        document.addEventListener(evt, schedule);
      }
    );
  }

  function setupObservers() {
    const root = document.querySelector('#MainContent') || document.body;
    if (!root) return;

    const obs = new MutationObserver(function (mutations) {
      for (const m of mutations) {
        if (m.type !== 'childList') continue;
        if (m.addedNodes && m.addedNodes.length) {
          schedule();
          break;
        }
      }
    });

    obs.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      schedule();
      setupVariantListeners();
      setupObservers();
    });
  } else {
    schedule();
    setupVariantListeners();
    setupObservers();
  }
})();


(function () {
  const SALES_SEL = '.product-block.product-block--sales-point';
  const INV_SEL = '.product-block.product-block--inventory';
  const WRAP_CLASS = 'product-block__deliveryandpayment';

  function findCommonParentWithInventory(salesEl) {
    let node = salesEl;
    while (node && node !== document.documentElement) {
      if (node.querySelector && node.querySelector(INV_SEL)) return node;
      node = node.parentElement;
    }
    return null;
  }

  function wrapPair(root) {
    const salesBlocks = (root || document).querySelectorAll(SALES_SEL);

    salesBlocks.forEach((salesEl) => {
      if (salesEl.closest('.' + WRAP_CLASS)) return;

      const commonParent = findCommonParentWithInventory(salesEl);
      if (!commonParent) return;

      const invEl = commonParent.querySelector(INV_SEL);
      if (!invEl) return;

      const existingWrap = invEl.closest('.' + WRAP_CLASS);
      if (existingWrap) {
        existingWrap.insertBefore(salesEl, existingWrap.firstChild);
        return;
      }

      const wrap = document.createElement('div');
      wrap.className = WRAP_CLASS;

      const parent = salesEl.parentNode;
      if (!parent) return;

      parent.insertBefore(wrap, salesEl);

      wrap.appendChild(salesEl);
      wrap.appendChild(invEl);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    wrapPair(document);
  });

  const obs = new MutationObserver(() => wrapPair(document));
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();


